<template>
  <div>
    <Header></Header>
    <div class="shared_page" v-if="validate != true">
      <h4>Vinculo invalido o ya fue caducado.</h4>
      <div class="cen-copy">
        <p>
          El link actual no es valido o ya caduco, solicite un nuevo link
          valido.
        </p>
        <v-btn to="/">Regresar a la página principal</v-btn>
      </div>
    </div>
    <div class="shared_page" v-else>
      <div v-if="info == false" class="cen-copy">
        <div class="ctn-icon">
          <v-icon>mdi-folder</v-icon>
        </div>
        <h4>Se quiere compartir la siguiente carpeta</h4>
        <p>
          donde podrás tener acceso a
          <b>{{ token.access }} </b> <br />
          la información o participar.
        </p>
        <v-form
          ref="form"
          v-model="valid"
          method="post"
          enctype="multipart/form-data"
          lazy-validation
        >
        </v-form>
        <v-btn
          :disabled="!valid"
          depressed
          large
          color="primary"
          @click="validForm"
          >Aceptar</v-btn
        >
      </div>
      <div class="shared_page" v-if="info == true">
        <h4>
          Ya puedes revisar la carpeta o el espacio compartido en tu sistema.
        </h4>
        <v-btn to="/">Regresar a la página principal</v-btn>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
//import SnackbarComp from '@/components/Snackbar.vue'

import { mapActions } from "vuex";
export default {
  name: "SharedPage",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      valid: true,
      token: null,
      info: false,
    };
  },
  async created() {
    await this.queryToken();
  },
  methods: {
    ...mapActions(["SharedTokenValid", "shareUpdateAccess"]),
    async queryToken() {
      this.token = await this.SharedTokenValid(this.$route.params.token);
    },
    validForm() {
      if (this.$refs.form.validate()) {
        this.update();
        console.log("update Shared");
      }
    },
    async update() {
      try {
        let form = {
          _id: this.token._id,
          token: this.token.tokenShared.token,
          file: this.token.file,
          leave: this.token.access,
        };
        let responsed = await this.shareUpdateAccess(form);
        if (responsed == 200) {
          //console.log("creado", responsed);
          //this.$root.$emit("reload");
          this.info = true;
        }
      } catch (error) {
        this.$root.$emit("snackbar", {
          status: 404,
          visible: true,
          text: `Ocurrió un error inesperado - ${error}`,
        });
      }
    },
  },
  computed: {
    validate() {
      if (this.token != null) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/base";
</style>
